module.exports = __webpack_public_path__ + "static/media/mp.3680ccd9.svg";